import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { useHistory } from "../../utils/router";
import { getLink, objectToFormData, toast } from "../../utils/helpers";
import { apiUrl } from "../../utils/apiUrl";
import FormTemplate from "./FormTemplate";
import { postRequest } from "../../utils/request";

const CreateTemplate = () => {
   const history = useHistory();
    const location = useLocation();

    const [errors, setErrors] = useState({});
    const [saving, setSaving] = useState(false);
    const [template, setTemplate] = useState({
        titulo: '',
        content: '',
        tipo: 'EMPLEADOS',
    });
    const [esValido, setEsValido] = useState(false);

    const cancelar = () => {
        const from = location.state?.from || getLink("/cartas/plantillas");

        history.push(from);
    }

    const crear = async (exit = true) => {
        if (!esValido) return toast('Favor llenar todos los campos requeridos', 'error');

        setSaving(true);

        setErrors({});

        const data = objectToFormData(template);

        const response = await postRequest(apiUrl("templates"), data);

        
        if (response.success) {
            setTemplate({
                titulo: '',
                content: '',
                tipo: 'EMPLEADOS'
            });

            toast('Plantilla Creado', 'success');

            if (exit) history.push(getLink("/cartas/plantillas"));
        }
        if (response.code === 422) {
            setErrors(response.data.message);
        }

        setSaving(false);
    };

    return <>
        <div className="row">
            <div className="col-md-12 order-2 order-md-1">
                <div className="card px-3 py-4" style={{borderRadius: '8px', minHeight: '100%'}}>
                    <h1>Crear Plantilla</h1>

                    <FormTemplate template={template} setTemplate={setTemplate} setEsValido={setEsValido} errors={errors} saving={saving} />
                </div>
            </div>
        </div>

        <div className="row pt-4">
            <button
                type="button"
                className="btn btn-plain ml-auto mr-2"
                onClick={cancelar}
            >
                Descartar
            </button>

            <button
                type="button"
                className="btn btn-outline-primary mx-2"
                onClick={() => crear(false)}
            >
                Guardar y crear nueva
            </button>

            <button
                type="button"
                className="btn btn-primary ml-2 mr-3"
                onClick={() => crear(true)}
            >
                Guardar
            </button>
        </div>
    </>;
};

export default CreateTemplate;
